// 按需 全局引入vant组件
import Vue from 'vue'
import { Calendar, Divider } from 'vant'

Vue.use(Calendar)
Vue.use(Divider)
